import { useEffect, useRef } from 'react';
import { useInterval } from '@wix/answers-lib';
var DATA_BI_HOOK = 'data-hook';
export var EventActivityType;
(function (EventActivityType) {
    EventActivityType["SCROLL"] = "scroll";
    EventActivityType["MOUSEMOVE"] = "mousemove";
    EventActivityType["CLICK"] = "click";
    EventActivityType["TYPING"] = "keydown";
})(EventActivityType || (EventActivityType = {}));
var TypingActivityType;
(function (TypingActivityType) {
    TypingActivityType["INTERNAL_REPLY_TYPING"] = "internal-reply";
    TypingActivityType["PUBLIC_REPLY_TYPING"] = "public-reply";
})(TypingActivityType || (TypingActivityType = {}));
export var UserEngagementPinger = function (_a) {
    var onPing = _a.onPing, pingInterval = _a.pingInterval;
    var initialActivities = new Set();
    var loggedActivitiesRef = useRef(initialActivities);
    useInterval(function () {
        if (!document.hidden) {
            onPing(Array.from(loggedActivitiesRef.current));
        }
        loggedActivitiesRef.current.clear();
    }, pingInterval);
    var updateActivities = function (activity) { return loggedActivitiesRef.current.add(activity); };
    var handleClick = function () { return updateActivities(EventActivityType.CLICK); };
    var handleScroll = function () { return updateActivities(EventActivityType.SCROLL); };
    var handleMousemove = function () { return updateActivities(EventActivityType.MOUSEMOVE); };
    var handleTyping = function (e) {
        var _a;
        var target = e.target;
        var typingType = ((_a = target.closest("[".concat(DATA_BI_HOOK, "]"))) === null || _a === void 0 ? void 0 : _a.getAttribute(DATA_BI_HOOK)) || '';
        if (Object.values(TypingActivityType).includes(typingType)) {
            // If typingType is a valid ActivityType, update activities accordingly.
            updateActivities(typingType);
        }
        else {
            updateActivities(EventActivityType.TYPING);
        }
    };
    useEffect(function () {
        window.addEventListener(EventActivityType.CLICK, handleClick);
        window.addEventListener(EventActivityType.SCROLL, handleScroll, { capture: true });
        window.addEventListener(EventActivityType.MOUSEMOVE, handleMousemove);
        window.addEventListener(EventActivityType.TYPING, handleTyping);
        return function () {
            window.removeEventListener(EventActivityType.CLICK, handleClick);
            window.removeEventListener(EventActivityType.SCROLL, handleScroll);
            window.removeEventListener(EventActivityType.MOUSEMOVE, handleMousemove);
            window.removeEventListener(EventActivityType.TYPING, handleTyping);
        };
    }, []);
    return null;
};
//# sourceMappingURL=index.js.map